import { css } from '@emotion/react';
import { Col, Row, Tabs, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Button } from '@/components/button';
import { PlusOutlined } from '@ant-design/icons';
import FoodSingleManagementTable from '@/components/tables/food-management/food-management-single.table';
import {
  getListDishAge,
} from '@/redux/slices/dish.slice';
import { PermissionMode } from '@/enums/mode.enum';
import { useAppDispatch } from '@/redux/hooks';
import { PageURLs } from '@/utils/navigate';
import { useQuery } from '@/hooks/query.hook';
import GroupFood from '@/components/tables/food-management/food-management-group.table';
import usePermission from '@/hooks/permission.hook';

export default function FoodManagement() {
  const [activeTab, setActiveTab] = useState('SINGLE');
  const { creatable, importable } = usePermission();

  const dispatch = useAppDispatch();
  const { push } = useQuery();

  useEffect(() => {
    dispatch(getListDishAge());
  }, [dispatch]);
  const items = [
    { key: 'SINGLE', label: 'Thực phẩm' },
    { key: 'GROUP', label: 'Nhóm thực phẩm' },
  ];

  const onAdd = () => {
    setActiveTab('CREATE');
    push(
      `${PageURLs.ofFoodManagement()}?mode=${PermissionMode.CREATE}`
    );
  };

  const onAddByGroup = () => {
    setActiveTab('CREATE_BY_LIST');
    push(
      `${PageURLs.ofFoodManagement()}?mode=${PermissionMode.CREATE_BY_LIST}`
    );
  };

  const onAddQuantificationByGroup = () => {
    setActiveTab('QUANTITY_BY_LIST');
    push(
      `${PageURLs.ofFoodManagement()}?mode=${PermissionMode.QUANTIFICATION}`
    );
  };

  return (
    <div css={rootStyles}>
      {!['CREATE', 'QUANTITY_BY_LIST', 'CREATE_BY_LIST'].includes(activeTab) && (
        <>
          <Row css={boxStyles} justify="space-between" align="middle">
            <Col>
              <Typography.Title css={titleStyles} level={5}>
                Quản lý thực phẩm
              </Typography.Title>
            </Col>
            {activeTab === 'SINGLE' && (
              <Col>
                <Row justify="space-between" css={{ gap: '10px' }}>
                  {creatable && (
                    <Button
                      icon={<PlusOutlined />}
                      iconPosition="start"
                      onClick={onAdd}
                      css={selfInputButtonStyles}
                    >
                      Tự nhập giá trị dinh dưỡng của từng loại thực phẩm
                    </Button>
                  )}
                  {importable && (
                    <>
                      <Button
                        onClick={onAddByGroup}
                        css={listInputButtonStyles}
                      >
                        Nhập giá trị dinh dưỡng của thực phẩm theo danh sách
                      </Button>
                      <Button
                        onClick={onAddQuantificationByGroup}
                        css={quantificationInputButtonStyles}
                      >
                        Nhập định lượng thực phẩm
                      </Button>
                    </>
                  )}
                </Row>
              </Col>
            )}
          </Row>

          <Tabs
            css={tabStyle}
            defaultActiveKey="SINGLE"
            onChange={(key) => setActiveTab(key)}
          >
            {items.map((item) => (
              <Tabs.TabPane tab={item.label} key={item.key} />
            ))}
          </Tabs>
        </>
      )}

      <div css={contentStyles}>
        {activeTab === 'SINGLE' && <FoodSingleManagementTable />}
        {activeTab === 'GROUP' && <GroupFood />}
      </div>
    </div>
  );
}

const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const contentStyles = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const tabStyle = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 8px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
  }

  .ant-tabs-tab:not(:first-of-type) {
    margin: 0 0 0 8px !important;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color);
    border: 1px solid var(--blue-dark-color);
    .ant-tabs-tab-btn {
      color: #ffffff !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const selfInputButtonStyles = css`
  color: var(--blue-light-color);
  border-color: var(--blue-light-color);

  &:hover {
    background-color: var(--white-color) !important;
    color: var(--blue-light-color) !important;
    border-color: var(--blue-light-color) !important;
  }
`;

const listInputButtonStyles = css`
  background-color: var(--success-color);
  color: var(--white-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;

const quantificationInputButtonStyles = css`
  background-color: var(--white-color);
  color: var(--success-color);
  border-color: var(--success-color);

  &:hover {
    background-color: var(--white-color) !important;
    color: var(--success-color) !important;
    border-color: var(--success-color) !important;
  }
`;